/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import Widget from '../../common/Widget/Widget'
import { GoogleMapComponent } from '../../common/GoogleMap/GoogleMap'
import Tabs from '../../common/Tabs/Tabs'
import ClientsTable from '../Clients/components/ClientsTable'
import ClientsTableHeader from '../Clients/components/ClientsTableHeader'
import Container from '../../common/Container/Container'
import ActivityTracker from './components/ActivityTracker'
import AgencySummary from './components/AgencySummary'
import DashboardFooter from './components/Footer'
import PopUp from '../../common/PopUp/PopUp'
import { Button } from '../../common/Button/Button'
import DatePicker from '../../common/DatePicker/DatePicker'
import { CloseIcon } from '../../../images/icons/Close/Close'
/**
 *     Import
 *     - CSS
 */
import './styles/Dashboard.css'
import '../Clients/styles/Clients.css'
import PolicyIdField from '../../common/PolicyId/PolicyId'

/**
 * Creates a Dashboard class
 *
 * @export Dashboard
 * @class Dashboard
 * @extends {React.Component<any, any>}
 */
export default class Dashboard extends React.Component<any, any> {

    /**
     * Creates an instance of Dashboard.
     * @param {*} props
     * @memberof Dashboard
     */
    constructor(props: any) {
        super(props)
        this.state = {
            markers: [

            ],
            activityTrackertimePeriod: '12 M',
            activityTrackerDataTab: 'New policies',
            summarytimePeriod: '12 M',
            activityTrackerData: [],
            agencySummaryTab: 'myStats',
            bindPopUp: {
                show: false,
                quoteId: '',
                isCommercialProperty: false,
                policyNumber: null,
                quoteVariationId: '',
                quoteType: '',
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: Number,
                commission: '',
                excess: Number,
                isCollectors: false,
                isDealersStock: false,
                isMuseums: false,
                isWineSpirits: false,
                bespokePolicyId: '',
            },
            bindPopUpSendShow: false,
            quoteVariationId: '',
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            Collectables: true,
            CollectableFilterBtn: false,
            ArtFilterBtn: false,
            AllBin: false,
            Arts: true,
            museums: true,
            museumsFilterBtn: false,
            dealers: true,
            dealersFilterBtn: false,
            wine: true,
            wineFilterBtn: false,
            CpHiscox: true,
            CpHiscoxFilterbtn: false,
            CpHcc: true,
            CpHccFilterBtn: false,
            boundBind: false,
            bindLoading: false,
            bindError: false,
        }
    }

    /**
     * Fetch the TrackerActivities at the begining
     *
     * @memberof Dashboard
     */
    componentWillMount() {
        this.props.fecthTrackerActivityTypes('newpolicies')
        this.props.fecthPolicyMap()
        this.props.fecthQuoteList()
    }

    /**
     * Will update the data if it receives a new one by props
     *
     * @param {*} nextProps
     * @memberof Dashboard
     */
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.activityTracker.response &&
            (nextProps.activityTracker.response.policiesMap !== this.state.activityTrackerData)) {
            this.setState({ activityTrackerData: nextProps.activityTracker.response.policiesMap })
        }
        if (nextProps.policyMap.response &&
            (nextProps.policyMap.response.markers !== this.state.markers)) {
            this.setState({ markers: nextProps.policyMap.response.markers })
        }
        if (nextProps.step05.done &&
            this.props.step05.done !== nextProps.step05.done) {
            this.props.fecthQuoteList()
        }
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fecthQuoteList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType
            )
        }
    }

    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    /**
     * Will handle a click of a marker and will close it or open it
     *
     * @param {string}  state - The state of the marker
     * @param {number}  index - The index of the array of markers
     *
     * @memberof Dashboard
     */
    onMarkerClick = (state: string, index: number) => {
        let provMarkers = this.state.markers
        // console.log(state,index)

        this.state.markers.map((item, i) => {
            if (index === i) {
                provMarkers[i].isOpen = !provMarkers[i].isOpen
            } else {
                provMarkers[i].isOpen = false
            }
        })

        this.setState({ markers: provMarkers })
        this.forceUpdate()
    }

    /**
     * Will add all the labels ad the bottom of the widget
     *
     * @memberof Dashboard
     */
    generateActivityTrackerLabels = () => {
        let labelList = [] as string[]

        if (this.state.activityTrackerData.length > 0) {
            switch (this.state.activityTrackertimePeriod) {
                case '12 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[2][0].date.split('-')[1], 12)

                    break

                case '6 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[1][0].date.split('-')[1], 6)

                    break

                case '3 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[0][0].date.split('-')[1], 3)

                    break

                default:
                    break
            }
        }

        return labelList.map((label, key) => {
            return (
                <div key={'label' + key}>{label}</div>
            )
        })
    }

    /**
     * Will change the period time to 3M 6M or 12M
     * It needs to have an event to avoid setState loops
     *
     * @memberof Dashboard
     * @param {*} event the event that calls the function
     */
    changeDataTimePeriod = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case '12 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '12 M',
                        }
                    )
                    break
                case '6 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '6 M',
                        }
                    )
                    break
                case '3 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '3 M',
                        }
                    )
                    break

                default:
                    break
            }
        }
    }

    /**
     * Will change the period time to 3M 6M or 12M
     * It needs to have an event to avoid setState loops
     *
     * @memberof Dashboard
     * @param {*} event the event that calls the function
     */
    changeSummaryDataTimePeriod = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case '12 M':
                    this.setState(
                        {
                            summarytimePeriod: '12 M',
                        }
                    )
                    break
                case '6 M':
                    this.setState(
                        {
                            summarytimePeriod: '6 M',
                        }
                    )
                    break
                case '3 M':
                    this.setState(
                        {
                            summarytimePeriod: '3 M',
                        }
                    )
                    break

                default:
                    break
            }
        }
    }

    handleFooterClick = () => {
        this.setState({ filters: { perPage: this.state.filters.perPage + 20 } })
    }

    /**
     * Will calculate all the bottom labels of the ActivityTracker widget from the data received
     * from the server. Will get the first month and calculate the following months depending on
     * the time period selected
     *
     * @memberof Dashboard
     * @param {number} month the first mont of the list
     * @param {number} numberOfMonths number of months to generate
     *
     */
    calculateMonth = (month: number, numberOfMonths: number) => {
        let activityTrackerLabels =
            ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let finalArray = [] as string[]
        for (let i = (month - 1); i < (Number(month) + Number(numberOfMonths)) - 1; i++) {
            if (i >= 12) {
                finalArray.push(activityTrackerLabels[i - 12])
            } else {
                finalArray.push(activityTrackerLabels[i])
            }
        }
        return finalArray
    }

    /**
     * Will fecth the new data of the ActivityTracker widget
     *
     * @memberof Dashboard
     */
    changeDataPoints = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case 'New policies':
                    this.props.fecthTrackerActivityTypes('newpolicies')
                    this.setState({ activityTrackerDataTab: 'New policies' })
                    break

                case 'Quotes':
                    this.props.fecthTrackerActivityTypes('quotes')
                    this.setState({ activityTrackerDataTab: 'Quotes' })
                    break

                case 'NTU':
                    this.props.fecthTrackerActivityTypes('ntu')
                    this.setState({ activityTrackerDataTab: 'NTU' })
                    break

                case 'Renewals':
                    this.props.fecthTrackerActivityTypes('renewals')
                    this.setState({ activityTrackerDataTab: 'Renewals' })
                    break

                case 'Lapsed':
                    this.props.fecthTrackerActivityTypes('lapsed')
                    this.setState({ activityTrackerDataTab: 'Lapsed' })
                    break

                case 'All live policies':
                    this.props.fecthTrackerActivityTypes('livepolicies')
                    this.setState({ activityTrackerDataTab: 'All live policies' })
                    break

                default:
                    break
            }
        }
    }

    changeAgencySummaryTabs = (event: any) => {
        if (event) {
            this.setState(
                {
                    agencySummaryTab: event.target.innerHTML
                        .replace(/\s(.)/g, function ($1: string) { return $1.toUpperCase() })
                        .replace(/\s/g, '')
                        .replace(/^(.)/, function ($1: string) { return $1.toLowerCase() }),
                }
            )
        }
    }

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any, inceptionDate: any, bespokePolicyId: any) => {
        this.setState({ bindLoading: true })
        this.props.bindQuoteVariation(quoteId, quoteVariationId, inceptionDate, bespokePolicyId).then((response) => {
            if (response.value) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: true,
                            bindLoading: false,
                        })
                    },
                    300)
            }
        }).catch((response) => {
            if (response.error) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: false,
                            bindLoading: false,
                        })
                    },
                    300)
            }
        })
        this.setState(
            {
                bindPopUp: {
                    show: false,
                    quoteId: '',
                    quoteVariationId: '',
                    businessName: '',
                    quoteRef: '',
                    inceptionDate: '',
                    printDate: '',
                    premium: Number,
                    commission: '',
                    excess: Number,
                    bespokePolicyId: '',
                    isCollectors: false,
                    isDealersStock: false,
                    isMuseums: false,
                    isWineSpirits: false,
                },
                bindPopUpSendShow: false,
                quoteVariationId,
            }
        )
    }

    printDate = () => {
        return this.state.bindPopUp.printDate
    }
    CollectablesisOpen = (name) => {
        this.setState({
            [name]: !this.state[name],
        })
    }

    handleInput = (event) => {
        let _bindpopup = this.state.bindPopUp
        _bindpopup.bespokePolicyId = event.target.value
        this.setState({ bindPopUp: _bindpopup })
    }

    render() {
        // const { isCommercialProperty } = this.state.bindPopUp
        let quotesCount = (this.props.clientList.quoteList) ? this.props.clientList.quoteList.totalNumber : 0
        let quotesViewCount = (this.props.clientList.quoteList) ? this.props.clientList.quoteList.quotes : []
        return (
            <div className="dashboard">

                {
                    (this.props.step05.error) ?
                        < PopUp
                            title={this.props.step05.error.variation ? 'Quote Referred' : 'Something went wrong'}
                            buttonText="Close"
                            action={() => {
                                this.setState({ bindError: false })
                                this.props.step05.error = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.step05.error.error}
                        </ PopUp>
                        :
                        null
                }

                {
                    (this.state.bindLoading) ?
                        <PopUp
                            title="Quote Bound Loading"
                            action={() => { '' }}
                        >
                            ...loading
                        </PopUp> : null
                }

                {
                    (this.state.boundBind) ?
                        <PopUp
                            title="Quote Bound"
                            buttonText="Quote Bound"
                            action={() => this.setState({
                                boundBind: false,
                            })}
                        >
                            The quote has been bound
                        </PopUp> : null
                }

                {
                    this.state.bindPopUp.show &&
                    < PopUp
                        title="Select Inception Date"
                        buttonText="Cancel"
                        action={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: Number,
                                            commission: '',
                                            excess: Number,
                                            bespokePolicyId: '',
                                            isCollectors: false,
                                            isDealersStock: false,
                                            isMuseums: false,
                                            isWineSpirits: false,
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            <PolicyIdField
                                quoteType={this.state.bindPopUp.quoteType}
                                onChange={this.handleInput}
                            />
                            <div className="quotePreview__row">
                                <div className="text">
                                    Please enter the inception date:
                                </div>
                                <div className="quotePreview__row__inception_date">
                                    <DatePicker
                                        placeholder="Policy inception date"
                                        step05inceptionDate={this.printDate()}
                                        onChange={(inceptionDate) => this.setState(
                                            {
                                                bindPopUp:
                                                    { ...this.state.bindPopUp, inceptionDate, show: false },
                                                bindPopUpSendShow: true,
                                            }
                                        )}
                                        onFocus={() => null}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopUp >
                }
                {
                    (this.state.bindPopUpSendShow) ?
                        < PopUp
                            title="Do you want to bind this quote?"
                            buttonText="Bind"
                            action={
                                () => {
                                    this.handleBind(
                                        this.state.bindPopUp.quoteId,
                                        this.state.bindPopUp.quoteVariationId,
                                        this.state.bindPopUp.inceptionDate,
                                        this.state.bindPopUp.bespokePolicyId
                                    )
                                }
                            }
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={
                                () =>
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: false,
                                                quoteId: '',
                                                quoteVariationId: '',
                                                businessName: '',
                                                quoteRef: '',
                                                inceptionDate: '',
                                                printDate: '',
                                                premium: Number,
                                                commission: '',
                                                excess: Number,
                                                bespokePolicyId: '',
                                                isCollectors: false,
                                                isDealersStock: false,
                                                isMuseums: false,
                                                isWineSpirits: false,
                                            },
                                            bindPopUpSendShow: false,
                                        }
                                    )
                            }
                        >
                            <div className="quotePreview__box">
                                <div className="quotePreview__header">
                                    <div className="quotePreview__header__title">
                                        {this.state.bindPopUp.businessName}
                                    </div>
                                    <div className="quotePreview__header__subtitle">
                                        {this.state.bindPopUp.policyName || 'Art and Antiques Dealer'} Policy
                                    </div>
                                    <div className="quotePreview__header__policyInfo">
                                        Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Inception date</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Date quoted</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.printDate}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Premium</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{(this.state.bindPopUp.premium).toLocaleString('en-GB', {
                                                style: 'currency',
                                                currency: 'GBP',
                                            })}</span> inc.IPT
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Your commission</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Excess</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>
                                                {(typeof (this.state.bindPopUp.excess) === 'number') ?
                                                    (this.state.bindPopUp.excess).toLocaleString('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                    })
                                                    : `£${this.state.bindPopUp.excess}`
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PopUp > :
                        null
                }

                <Widget
                    className="policy-map"
                    shadow={true}
                >
                    <div className="widget__title">
                        <h4>Policy map</h4>
                    </div>
                    <div className="policy-map__content">
                        <div className="filter_buttons">
                            <a
                                className={`map_filter_btn ${this.state.Collectables ? 'collectors_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('Collectables')}
                            >
                                Collectables {this.state.Collectables ? <CloseIcon /> : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.Arts ? 'art_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('Arts')}
                            >
                                Arts and Antiques {this.state.Arts ? <CloseIcon /> : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.museums ? 'museums_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('museums')}
                            >
                                Museum - Exhibits Only {this.state.museums ? <CloseIcon />
                                    : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.dealers ? 'dealers_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('dealers')}
                            >
                                Dealers - Stock Only {this.state.dealers ? <CloseIcon />
                                    : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.wine ? 'wine_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('wine')}
                            >
                                Wine & Spirits {this.state.wine ? <CloseIcon /> : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.CpHiscox ? 'hiscox_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('CpHiscox')}
                            >
                                CP-Hiscox {this.state.CpHiscox ? <CloseIcon /> : <span className="icon-space" />}
                            </a>
                            <a
                                className={`map_filter_btn ${this.state.CpHcc ? 'hcc_buttons' : null}`}
                                onClick={() => this.CollectablesisOpen('CpHcc')}
                            >
                                CP-Hcc {this.state.CpHcc ? <CloseIcon /> : <span className="icon-space" />}
                            </a>
                        </div>
                        <GoogleMapComponent
                            defaultZoom={7}
                            defaultCenter={{ lat: 51.449749, lng: -0.967350 }}
                            markers={this.state.markers}
                            isMarkerShown={true}
                            onMarkerClick={(state, index) => { this.onMarkerClick(state, index) }}
                            Collectables={this.state.Collectables}
                            art={this.state.Arts}
                            museums={this.state.museums}
                            dealers={this.state.dealers}
                            wine={this.state.wine}
                            CpHiscox={this.state.CpHiscox}
                            CpHcc={this.state.CpHcc}
                            AllBin={this.state.AllBin}

                        />
                    </div>
                </Widget>
                <Widget
                    className="activity-tracker"
                    shadow={true}
                >
                    <div className="widget__title widget__title--underline">
                        <h4>Activity tracker</h4>
                    </div>
                    <Tabs
                        tabs={[
                            { name: 'New policies', function: this.changeDataPoints, position: 'left', selected: true },
                            { name: 'Quotes', function: this.changeDataPoints, position: 'left', selected: false },
                            { name: 'NTU', function: this.changeDataPoints, position: 'left', selected: false },
                            { name: 'Renewals', function: this.changeDataPoints, position: 'left', selected: false },
                            { name: 'Lapsed', function: this.changeDataPoints, position: 'left', selected: false },
                            {
                                name: 'All live policies', function: this.changeDataPoints,
                                position: 'left', selected: false,
                            },
                            { name: '12 M', function: this.changeDataTimePeriod, position: 'right', selected: true },
                            { name: '6 M', function: this.changeDataTimePeriod, position: 'right', selected: false },
                            { name: '3 M', function: this.changeDataTimePeriod, position: 'right', selected: false },
                        ]}
                    />
                    <ActivityTracker
                        data={this.state.activityTrackerData[
                            (this.state.activityTrackertimePeriod === '12 M') ?
                                2 :
                                ((this.state.activityTrackertimePeriod === '6 M') ?
                                    1 :
                                    0)
                        ]}
                        chartWidth={940}
                        chartHeight={360}
                        margin={{ top: 90, right: 0, left: 0, bottom: 0 }}
                        horizontalGrid={false}
                        verticalGrid={true}
                        activityTrackerDataTab={this.state.activityTrackerDataTab}
                        verticalGridLines={(this.state.activityTrackertimePeriod === '12 M') ?
                            11 :
                            ((this.state.activityTrackertimePeriod === '6 M') ?
                                5 :
                                2)}
                        horizontalGridLines={(this.state.activityTrackertimePeriod === '12 M') ?
                            11 :
                            ((this.state.activityTrackertimePeriod === '6 M') ?
                                5 :
                                2)}
                    />
                    <div className="activity-tracker__footer">
                        {this.generateActivityTrackerLabels()}
                    </div>
                </Widget>
                <Widget
                    className="agency-summary"
                    shadow={true}
                >
                    <div className="widget__title widget__title--underline">
                        <h4>Agency summary</h4>
                    </div>
                    <Tabs
                        tabs={[
                            {
                                name: 'My stats', function: this.changeAgencySummaryTabs,
                                position: 'left', selected: true,
                            },
                            {
                                name: 'Agency stats', function: this.changeAgencySummaryTabs,
                                position: 'left', selected: false,
                            },
                            {
                                name: '12 M',
                                function: this.changeSummaryDataTimePeriod,
                                position: 'right',
                                selected: true,
                            },
                            {
                                name: '6 M',
                                function: this.changeSummaryDataTimePeriod,
                                position: 'right',
                                selected: false,
                            },
                            {
                                name: '3 M',
                                function: this.changeSummaryDataTimePeriod,
                                position: 'right',
                                selected: false,
                            },
                        ]}
                    />
                    <AgencySummary
                        fetchAgencySummary={() => { this.props.fetchAgencySummary() }}
                        agencySummary={this.props.agencySummary}
                        summarytimePeriod={
                            this.state.summarytimePeriod === '12 M' ? 2 :
                                (this.state.summarytimePeriod === '6 M') ? 1 : 0
                        }
                        tabSelected={this.state.agencySummaryTab}
                    />
                </Widget>
                <Widget
                    className="your-quotes"
                    shadow={true}
                >
                    <div className="widget__title widget__title--underline">
                        <h4>Your quotes</h4>
                    </div>
                    <div className="your-quotes__content">
                        <Container className="clients clients__table table__content" fullwidth={false}>
                            <ClientsTableHeader
                                dataType="quotes"
                                filterTrigger={this.filterTrigger}
                            />
                            <ClientsTable
                                clientList={this.props.clientList}
                                dataType="quotes"
                                confirmEditQuote={this.props.confirmEditQuote}
                                history={this.props.history}
                                bindClick={
                                    (quote, variation) => {
                                        this.setState(
                                            {
                                                bindPopUp: {
                                                    show: true,
                                                    quoteId: quote.id,
                                                    isCommercialProperty: quote.isCommercialProperty,
                                                    quoteVariationId: variation.id,
                                                    policyNumber: variation.hiscoxPolicyNo,
                                                    quoteType: variation.quoteType,
                                                    businessName: quote.clientName,
                                                    quoteRef: variation.quoteRef,
                                                    inceptionDate: '',
                                                    printDate: quote.quotedDate,
                                                    premium: variation.premium,
                                                    commission: variation.commission,
                                                    excess: variation.excess,
                                                    policyName: quote.policyName,
                                                    bespokePolicyId: '',
                                                    isCollectors: quote.isCollectors,
                                                    isDealersStock: quote.isDealersStock,
                                                    isMuseums: quote.isMuseums,
                                                    isWineSpirits: quote.isWineSpirits,
                                                },
                                            }
                                        )
                                    }
                                }
                            />
                            <Button
                                onClick={this.handleFooterClick}
                                disabled={quotesViewCount.length === quotesCount}
                            >
                                Load more
                            </Button>
                        </Container>
                    </div>
                </Widget>
                <DashboardFooter goTo={this.props.history.push} />
            </div >
        )
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Dashboard/Dashboard.tsx